module.exports = __webpack_public_path__ + "media/living_on_a_budget/decorate_feature_article_img-d3e7d863.png";